module.exports = __webpack_public_path__ + "static/img/cambodia.ab3c821.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/cambodia.jpg
// module id = PvP2
// module chunks = 1